import React, { forwardRef } from 'react';

import { ImageProps } from './types';

const Image = forwardRef<HTMLImageElement, ImageProps>(({ resizeMode, ...props }, ref) => {
  // @ts-ignore
  return <img ref={ref} {...props} />;
});

Image.displayName = 'Image';

export default Image;
